import forEach from '../../../../javascripts/dom/forEach';

const bentoslider = document.querySelectorAll('[data-js-module="o-bento-slider"]');

const init = async () => {
  const { default: Bentoslider } = await import(/* webpackChunkName: "o-bento-slider" */ './bentoslider');
  forEach(bentoslider, (index, element) => new Bentoslider(element));
};

if (bentoslider.length) init();
